import styled, { css } from 'styled-components';
import { CheckmarkIcon, colors, breakpoints, font, zindex, spacing } from '@chegg-ui/theme';
import { FULL_PM_VIEW_CLASS, PAYMENT_LEFT_CLASS, PAYMENT_RIGHT_CLASS } from './constants';
import { Typography } from '@chegg-ui/typography';
import { SaleBannerWithBadge } from '@chegg/commerce-utils';
import React from 'react';
var weight = font.weight,
  size = font.size;
var cheggOrange = colors.cheggOrange,
  greyLight = colors.greyLight,
  white = colors.white,
  grey100 = colors.grey100;
var md = breakpoints.md,
  lg = breakpoints.lg;
var bold = weight.bold,
  medium = weight.medium;
var px24 = size.px24,
  px16 = size.px16,
  px12 = size.px12;
export var CenteredWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-0"
})(["width:100%;height:100%;background:", ";position:absolute;overflow:hidden;justify-content:center;align-items:center;display:", ";z-index:", ";"], white, function (props) {
  return props.isCTALoading ? 'flex' : 'none';
}, zindex.modal);
export var DropInPaymentsOverlay = styled.div.withConfig({
  componentId: "sc-1teqjd8-1"
})(["background:", ";position:relative;"], white);
export var CartCheckoutWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-2"
})(["position:relative;height:100%;@media screen and (max-width:", "){padding:0 5px;height:100%;}"], md.max);

/* istanbul ignore next */
export var PaymentWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-3"
})(["&&&{display:flex;", ";justify-content:", ";", " ", " > div{", ";&.", "{width:100%;margin:auto;}}.", "{padding:20px;}.", "{margin-top:20px;margin-bottom:20px;}@media screen and (max-width:", "){", " > div{width:100%;&.", "{width:95%;}}.", "{padding:0;}}}"], function (_ref) {
  var newUserNoMop = _ref.newUserNoMop,
    allowPlanSelection = _ref.allowPlanSelection,
    eligibleForCSPUpgrade = _ref.eligibleForCSPUpgrade,
    isMultimonthResubscribe = _ref.isMultimonthResubscribe;
  return !newUserNoMop && !allowPlanSelection || eligibleForCSPUpgrade || isMultimonthResubscribe ? "flex-direction: row;" : "flex-direction: column;";
}, function (props) {
  return props.onlyPM ? 'center' : 'space-between';
}, function (_ref2) {
  var eligibleForCSPUpgrade = _ref2.eligibleForCSPUpgrade,
    isMultimonthResubscribe = _ref2.isMultimonthResubscribe;
  return (eligibleForCSPUpgrade || isMultimonthResubscribe) && "border-bottom: 1px solid #e7e7e7;";
}, function (_ref3) {
  var isReviewStep = _ref3.isReviewStep;
  return isReviewStep && "\n      [data-test='PAYMENT_HEADER'] {\n        display: none;\n      }\n    ";
}, function (_ref4) {
  var newUserNoMop = _ref4.newUserNoMop,
    allowPlanSelection = _ref4.allowPlanSelection,
    eligibleForCSPUpgrade = _ref4.eligibleForCSPUpgrade;
  return (!newUserNoMop && !allowPlanSelection || eligibleForCSPUpgrade) && "width: 50%";
}, FULL_PM_VIEW_CLASS, PAYMENT_RIGHT_CLASS, PAYMENT_LEFT_CLASS, md.max, function (_ref5) {
  var eligibleForCSPUpgrade = _ref5.eligibleForCSPUpgrade;
  return !eligibleForCSPUpgrade && "flex-direction: column;";
}, FULL_PM_VIEW_CLASS, PAYMENT_RIGHT_CLASS);
export var CTAWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-4"
})(["display:flex;flex-direction:row;@media screen and (max-width:", "){flex-direction:column;div button{margin-top:5px;}}"], md.max);
export var PricingWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-5"
})(["&&&{display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding:10px 5px 0px 5px;border-top:1px solid ", ";p{display:inline;}@media screen and (min-width:", "){> button{margin-right:5px;}}@media screen and (max-width:", "){flex-direction:column;padding:10px 10px 0 10px;background-color:", ";bottom:0;}}"], greyLight, lg.min, md.max, white);
export var Divider = styled.hr.withConfig({
  componentId: "sc-1teqjd8-6"
})(["border:none;border-top:1px solid ", ";height:1px;margin:10px 0;"], greyLight);
export var PaymentMethodHeading = styled.div.withConfig({
  componentId: "sc-1teqjd8-7"
})(["width:80%;font-weight:", ";font-family:", ";font-size:", ";margin-bottom:20px;position:relative;left:10%;@media screen and (max-width:", "){left:0;padding:0 15px;}"], bold, font.family.aspira, px24, md.max);
export var TaxWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-8"
})(["p{margin:0 0 10px 0;}"]);

/* istanbul ignore next */
export var TncWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-9"
})(["border-radius:", ";padding:", " ", ";line-height:1.2;background-color:", ";span{line-height:1.7;}span > h2{display:inline;font-size:", ";margin-top:0px;margin-bottom:0px;padding-right:5px;}", ""], spacing.px4, spacing.px4, spacing.px12, grey100, px12, function (_ref6) {
  var isOpen = _ref6.isOpen;
  return isOpen && "\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: ".concat(zindex.modal, ";\n  background-color: ").concat(white, ";\n  max-height: 100%;\n  overflow: auto;\n  ");
});
export var DevicePolicyWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-10"
})(["padding:0 ", ";h2{font-size:", ";display:inline;}"], size.px12, px12);
export var FinePrintWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-11"
})(["padding-top:20px;h2{margin:auto;padding-right:5px;line-height:1.6;margin-top:0;}p{margin-bottom:revert;display:inline;}"]);
export var ProductsWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-12"
})(["display:flex;justify-content:space-between;border-bottom:1px solid #e7e7e7;gap:36px;padding:20px 0;@media only screen and (max-width:", "){flex-direction:column;gap:16px;}"], breakpoints.md.min);
export var LayoutWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-13"
})(["display:flex;justify-content:space-between;border-bottom:1px solid ", ";gap:36px;padding:20px 0;@media only screen and (max-width:", "){flex-direction:column;gap:16px;}"], greyLight, breakpoints.lg.max);
export var MultiMonthWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-14"
})(["width:70%;p{margin-top:0px;font-weight:", ";font-size:1.25rem;}@media only screen and (max-width:", "){width:unset;}"], medium, breakpoints.lg.max);
export var ValuePropsWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-15"
})(["p{margin-top:0px;margin-bottom:", ";font-weight:", ";font-size:", ";}ul{padding:0;}li{padding-left:0;}", " @media only screen and (max-width:", "){p{margin-bottom:0;margin-top:", ";}}"], spacing.px48, bold, px16, function (_ref7) {
  var isMobile = _ref7.isMobile;
  return isMobile && "\n  display: none;\n  ";
}, breakpoints.lg.max, spacing.px16);
export var VariationsContainer = styled.div.withConfig({
  componentId: "sc-1teqjd8-16"
})(["display:flex;z-index:1;gap:24px;flex-direction:column;max-width:600px;"]);
export var ProductSection = styled.div.withConfig({
  componentId: "sc-1teqjd8-17"
})(["display:flex;flex-direction:column;width:100%;gap:8px;@media only screen and (max-width:", "){align-items:center;}"], breakpoints.md.min);
export var ListItemContainer = styled.div.withConfig({
  componentId: "sc-1teqjd8-18"
})(["display:flex;justify-content:flex-start;align-items:center;"]);
export var SelectionWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-19"
})(["display:flex;justify-content:space-between;align-items:center;gap:8px;@media only screen and (max-width:", "){min-width:300px;}"], breakpoints.md.min);
export var ListContainer = styled.div.withConfig({
  componentId: "sc-1teqjd8-20"
})(["display:flex;flex-direction:column;gap:4px;margin-left:24px;"]);
export var StyledCheckIcon = styled(CheckmarkIcon).attrs({
  color: cheggOrange,
  size: 'medium'
}).withConfig({
  componentId: "sc-1teqjd8-21"
})(["margin-right:8px;"]);
export var CtaContainer = styled.div.withConfig({
  componentId: "sc-1teqjd8-22"
})(["display:flex;justify-content:right;align-items:center;"]);
export var StickyFooterWrapperMobile = styled.div.withConfig({
  componentId: "sc-1teqjd8-23"
})(["display:flex;flex-direction:column;justify-content:center;"]);
export var StickyFooterWrapperDesktop = styled.div.withConfig({
  componentId: "sc-1teqjd8-24"
})(["div > button{width:400px;}display:flex;flex-direction:column;justify-content:center;align-items:center;"]);
export var StickyFooterTncWrapper = styled.div.withConfig({
  componentId: "sc-1teqjd8-25"
})(["margin-bottom:10px;"]);
export var StyledPrice = styled(Typography).withConfig({
  componentId: "sc-1teqjd8-26"
})(["", ""], function (_ref8) {
  var isDiscounted = _ref8.isDiscounted;
  return isDiscounted && css(["color:", ";"], colors.cheggOrange);
});
export var StyledBasePrice = styled(Typography).withConfig({
  componentId: "sc-1teqjd8-27"
})(["font-size:", ";text-decoration:line-through;"], font.size.px14);
export var StyledPriceContainer = styled.div.withConfig({
  componentId: "sc-1teqjd8-28"
})(["display:flex;flex-direction:column;align-items:end;"]);
export var StyledSaleBannerWithBadge = styled(function (props) {
  return /*#__PURE__*/React.createElement(SaleBannerWithBadge, props);
}).withConfig({
  componentId: "sc-1teqjd8-29"
})(["margin-bottom:", ";"], spacing.px40);
export var StyledCouponAppliedText = styled(Typography).withConfig({
  componentId: "sc-1teqjd8-30"
})(["font-size:", ";"], font.size.px12);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/styled.js
// module id = 214
// module chunks = 11